import { Box } from "@mui/material";

import { VisitStatusTimeline } from "~/shared/components/VisitStatusTimeline";
import { VisitStatusTimelineFragment } from "~/shared/components/VisitStatusTimeline/fragment.generated";

type VisitStatusSectionProps = {
    onClick: (date: Date) => void;
    possibleDays: VisitStatusTimelineFragment["possibleDays"];
    plannerStatus: VisitStatusTimelineFragment["plannerStatus"];
    selectedDate: Date;
};

export function VisitStatusSection({ onClick, possibleDays, plannerStatus, selectedDate }: VisitStatusSectionProps) {
    if (plannerStatus === "planned") {
        return null;
    }

    return (
        <Box
            padding={2}
            sx={theme => ({
                borderBottom: `1px solid ${theme.palette.divider}`,
                minWidth: 350,
            })}
            gap={2}
        >
            <VisitStatusTimeline
                onClick={onClick}
                possibleDays={possibleDays}
                selectedDate={selectedDate}
                plannerStatus={plannerStatus}
                variant="full"
            />
        </Box>
    );
}
